import { useEffect } from 'react';

export default function StandardCutNavBridge(){
 useEffect(()=>{
  const install=()=>{
   document.querySelectorAll('a[href="/depo/receteler"]').forEach(recipeLink=>{
    const parent=recipeLink.parentElement;if(!parent||parent.querySelector('a[data-standard-cut-link="1"]'))return;
    const a=document.createElement('a');
    a.href='/depo/standart-kesimler';
    a.target='_self';
    a.rel='';
    a.dataset.standardCutLink='1';
    a.className=recipeLink.className;
    a.innerHTML=recipeLink.innerHTML;
    const spans=a.querySelectorAll('span');
    const label=[...spans].find(x=>x.textContent?.includes('Reçeteler'));
    if(label)label.textContent='Standart Kesim Reçeteleri';
    else a.textContent='Standart Kesim Reçeteleri';
    a.addEventListener('click',event=>{
      if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      event.preventDefault();
      event.stopPropagation();
      window.location.assign('/depo/standart-kesimler');
    });
    recipeLink.insertAdjacentElement('afterend',a);
   });
  };
  install();
  const observer=new MutationObserver(install);observer.observe(document.body,{childList:true,subtree:true});
  return()=>observer.disconnect();
 },[]);
 return null;
}
